import dynamic from 'next/dynamic';
import { RedemptionsAlertProps } from './RedemptionNotification.types';

export const RedemptionNotification = dynamic<RedemptionsAlertProps>(() => import('./RedemptionNotification'));
